/*
 * � 2020 Microsoft. All rights reserved.
 */

define('util/NineSliceWrapper',['dependencies/libs/ninepatch/ninepatch', 'pixi'], function (NinePatch, PIXI) {
	var NineSliceWrapper = function (frame, width, height, left, right, top, bottom) {
		var originSprite = new PIXI.Sprite(PIXI.Texture.fromFrame(frame));
		this.originTexture = originSprite.generateTexture();
		this.frame = frame;

		var widthInMiddle = this.originTexture.width - right - left;
		var positionForRightTextures = this.originTexture.width - right;

		this.topLeftSprite = this.createCroppedSprite(0, 0, left, top);
		this.topCenterSprite = this.createCroppedSprite(left, 0, widthInMiddle, top);
		this.topRightSprite = this.createCroppedSprite(positionForRightTextures, 0, right, top);

		var heightInMiddle = this.originTexture.height - top - bottom;
		this.middleLeftSprite = this.createCroppedSprite(0, top, left, heightInMiddle);
		this.middleCenterTexture = this.createCroppedSprite(left, top, widthInMiddle, heightInMiddle);
		this.middleRightSprite = this.createCroppedSprite(positionForRightTextures, top, right, heightInMiddle);

		var positionFromTopForBottomLayers = this.originTexture.height - bottom;
		this.bottomLeftSprite = this.createCroppedSprite(0, positionFromTopForBottomLayers, left, bottom);
		this.bottomCenterSprite = this.createCroppedSprite(left, positionFromTopForBottomLayers, widthInMiddle, bottom);
		this.bottomRightSprite = this.createCroppedSprite(positionForRightTextures, positionFromTopForBottomLayers, right, bottom);

		this.layers = [];
		this.layers.push.apply(this.layers,
			[this.topLeftSprite, this.topCenterSprite, this.topRightSprite,
				this.middleLeftSprite, this.middleCenterTexture, this.middleRightSprite,
				this.bottomLeftSprite, this.bottomCenterSprite, this.bottomRightSprite]);
		NinePatch.call(this, width, height, this.layers);
	};

	NineSliceWrapper.prototype = Object.create(NinePatch.prototype);
	NineSliceWrapper.prototype.constructor = NineSliceWrapper;

	NineSliceWrapper.prototype.createCroppedSprite = function (left, top, width, height) {
		var rect, texture, sprite;
		var copyTexture = new PIXI.Texture(this.originTexture.baseTexture, this.frame);
		rect = new PIXI.Rectangle(left, top, width, height);
		texture = new PIXI.Texture(copyTexture, rect);
		sprite = new PIXI.Sprite(texture);
		return sprite;
	};

	return NineSliceWrapper;
});

